import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { authUserSelector } from '../../auth/redux/AuthRedux';
import { generateOriginReport } from '../services/DashboardCRUD';

export default function OriginReport() {
  const intl = useIntl();
  const authUser = useSelector(authUserSelector);
  const [loading, setLoading] = useState(false);

  async function handleGenerateReport() {
    try {
      setLoading(true);
      await generateOriginReport();
      toast.success(
        intl.formatMessage(
          { id: 'businessDashboard.originReportSuccess' },
          { email: authUser?.email }
        )
      );
    } catch (error) {
      toast.error(
        intl.formatMessage({ id: 'businessDashboard.originReportError' })
      );
      console.warn(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <h1 className="title mb-4">
        {intl.formatMessage({ id: 'businessDashboard.originReportTitle' })}
      </h1>
      <p className="mb-6">
        {intl.formatMessage({
          id: 'businessDashboard.originReportDescription',
        })}
      </p>
      <button
        className="btn btn-primary"
        style={{ width: 'fit-content' }}
        disabled={loading}
        onClick={handleGenerateReport}
      >
        {loading ? (
          <span className="spinner-border spinner-border-sm me-3"></span>
        ) : (
          <span className="fas fa-file-download me-3"></span>
        )}
        {intl.formatMessage({ id: 'businessDashboard.generateOriginReport' })}
      </button>
    </>
  );
}
